import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../../../services/formulacion/general.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-inicio-reversion',
  templateUrl: './inicio-reversion.component.html',
  styles: []
})
export class InicioReversionComponent implements OnInit {
  techos: any[];
  baseUrl = environment.apiEndpoint;
  rol: number = 0;
  constructor(private _gs: GeneralService) {
    this.getTechoByUO();
  }

  ngOnInit() {
  }

  getTechoByUO() {
    let u = JSON.parse(localStorage.getItem('u'));
    this.rol = u.rol;
    if (u != null) {
      this._gs.getTechoByUO(u.unidad).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.techos = result.data;
            
          } else {
            this.techos = [];
          }
        },
        (error) => { console.log('Error', error); });
    }
  }
}
